export function getTenantTimezone() {
  try {
    var tenant = JSON.parse(localStorage.getItem('lf_tenant') || 'null');
    return (tenant && tenant.settings && tenant.settings.timezone) || 'America/New_York';
  } catch (e) {
    return 'America/New_York';
  }
}

export function formatDate(value) {
  if (!value) return '';
  try {
    var tz = getTenantTimezone();
    return new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(new Date(value));
  } catch (e) {
    return new Date(value).toLocaleDateString();
  }
}

export function formatDateTime(value) {
  if (!value) return '';
  try {
    var tz = getTenantTimezone();
    return new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    }).format(new Date(value));
  } catch (e) {
    return new Date(value).toLocaleString();
  }
}

export function formatTimestamp(value) {
  if (!value) return '';
  try {
    var tz = getTenantTimezone();
    return new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    }).format(new Date(value));
  } catch (e) {
    return new Date(value).toLocaleString();
  }
}
